import React from 'react';
import {
  cn,
  Text,
  Checkbox,
  prettifyBytes,
  LoadingIcon,
  AttachmentsResponse,
} from '../../../../../../../UILibrary';

type FileListProps = {
  isLoading: boolean;
  isSelectingFiles?: boolean;
  items?: AttachmentsResponse['items'];
  checkedFileMap: Record<number, boolean>;
  selectedFileIndex: number | null;
  onFileClick: (idx: number) => void;
  onCheckboxClick: (idx: number) => void;
};

export function FileList({
  isLoading,
  isSelectingFiles,
  items,
  checkedFileMap,
  selectedFileIndex,
  onFileClick,
  onCheckboxClick,
}: FileListProps) {
  return (
    <div className="flex-1 overflow-auto pt-6 px-6">
      {!isLoading ? (
        <div className="flex flex-col gap-3">
          {items?.map((file, idx) => (
            <div
              key={file.name + idx}
              className={cn(
                'cursor-pointer flex items-start gap-2 w-full px-3 py-1 rounded-md',
                {
                  'bg-[#F5F5F7]': selectedFileIndex === idx,
                },
              )}
              onClick={() => onFileClick(idx)}
            >
              {isSelectingFiles && (
                <Checkbox
                  checked={!!checkedFileMap[idx]}
                  onClick={() => onCheckboxClick(idx)}
                />
              )}

              <div className="flex flex-col">
                <Text variant="Caption1" className="text-[#4D4E58]">
                  {file.name}
                </Text>
                <Text variant="Caption2" className="text-[#86868B]">
                  {file.type.toUpperCase()}, {prettifyBytes(file.size)}
                </Text>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="h-full flex items-center justify-center">
          <LoadingIcon />
        </div>
      )}
    </div>
  );
}
